export default __webpack_public_path__ + "static/media/incident_management_impression_mobile.3cddd499.png";